<template>
  <v-avatar
    rounded
    color="white"
    variant="elevated"
    :class="{
      'pa-2': size === 'default',
      'pa-1': size === 'small',
      'pa-5': size === 'medium',
      'pa-4': size === 'large',
    }"
    :style="{ padding: size === 'x-small' ? '0.15rem' : undefined }"
    :size="size"
  >
    <organization-file-image
      v-if="organization?.icon"
      :organization-id="organization._id"
      :default-icon="organizationIcon"
      :size="size"
      file-type="icon"
      width="32px"
      height="32px"
    />
    <v-icon v-else :size="size">{{ organizationIcon }}</v-icon>
  </v-avatar>
</template>

<script setup lang="ts">
const { organization = null, size = "default" } = defineProps<{
  organization?: Pick<Organization, "_id" | "icon" | "type"> | null
  size?: "default" | "small" | "x-small" | "medium" | "large"
}>()

const organizationIcon = computed(() => {
  if (!organization) {
    return "help_center"
  }

  return getOrganizationIconByType(organization.type)
})
</script>
